import { Pipe, PipeTransform } from "@angular/core";
import { Timestamp } from '@angular/fire/firestore';

@Pipe({
    name: 'sopoDate',
    standalone: false
})
export class SopoDatePipe implements PipeTransform { 
    transform(value: string | number | Date | Timestamp, options: Intl.DateTimeFormatOptions = { day: "2-digit", month: '2-digit', year: '2-digit' }, locale?: string): string { 
        if(!value) return '-';
        let newValue = value;
        let setLocale = locale ? locale : window.navigator.language;
        if (newValue instanceof Timestamp) newValue = newValue.toDate();
        if (typeof(newValue) === 'string') newValue = new Date(newValue);

        return new Intl.DateTimeFormat(setLocale, options).format(newValue).toString();
    }
}
